// extracted by mini-css-extract-plugin
export default {"container":"contact-us-footer_container__tHB7y","left":"contact-us-footer_left__Svse2","right":"contact-us-footer_right__0iLFC"};